import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import {
  PaymentScheduleTabName,
  ProgramTypesGUID
} from '../../../models/_enum-collections';
import {
  PaymentBatchList,
  PaymentBatchExportToCsv
} from '../../../models/payment-batch-list.model';
import { AppConstants } from '../../common/app-constants';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { CSIPaymentScheduleService } from '../../services/csi-payment-schedule.service';
import { ExportService } from '../../services/export.service';
import { PaymentScheduleService } from '../../services/payment-schedule.service';

@Component({
  selector: 'app-payment-batch-table',
  templateUrl: './payment-batch-table.component.html',
  styleUrls: ['./payment-batch-table.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class PaymentBatchTableComponent implements OnInit {
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  isSpin = false;
  PaymentTabName = PaymentScheduleTabName;

  @ViewChild('dt', { static: false }) dt!: Table;
  @Input() currentTabname!: PaymentScheduleTabName;
  @Input() program: ProgramTypesGUID | null = null;

  paymentBatchList: PaymentBatchList[] = [];
  pscols!: any[];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  isM1 = true;
  isM2 = false;
  datePipe = new DatePipe('en-US');
  paymentBatchExport: PaymentBatchExportToCsv[] = [];

  constructor(
    private router: Router,
    private pmService: PaymentScheduleService,
    private exportService: ExportService,
    public settings: SettingsService,
    private csiService: CSIPaymentScheduleService
  ) {}

  ngOnInit() {
    if (history.state.program) {
      this.program = history.state.program;
    }
    this.loading = true;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.pscols = [
      { field: 'paymentBatchName', header: 'Payment Batch Name' },
      {
        field: 'paymentBatchScheduleDate',
        header: 'Payment Batch Schedule Date'
      },
      { field: 'paymentBatchStatus', header: 'Payment Batch Status' },
      {
        field: 'actualPaymentCentralDate',
        header: 'Actual Payment Central Date'
      },
      { field: 'totalAmount', header: 'Total Amount' },
      { field: 'requestDetailIds', header: 'Engagement Ids' },
      { field: 'noOfEngagements', header: 'No of Engagement' },
      { field: 'partnersPaid', header: 'Partners Paid' }
    ];

    this.getAllPaymentBatch();
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.dt) {
      this.dt.sortField = 'paymentBatchName';
      this.dt.sortOrder = -1;
      this.dt.reset();
    }

    if (this.paymentBatchList === null || this.paymentBatchList.length === 0) {
      this.totalRecords = 0;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.getAllPaymentBatch();
      this.totalRecords = this.paymentBatchList.length;
      if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }

      if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }

  editPaymentBatchDetails(paymentBatchName: string) {
    const isMilestone1 =
      this.currentTabname === PaymentScheduleTabName.Milestone1;
    const isMilestone2 =
      this.currentTabname === PaymentScheduleTabName.Milestone2;
    if (this.program !== null) {
      if (isMilestone1) {
        this.router.navigate(
          ['/milestone1-edit-payment-batch', paymentBatchName],
          { queryParams: { program: this.program } }
        );
      } else if (isMilestone2) {
        this.router.navigate([
          '/csi-milestone2-edit-payment-batch',
          paymentBatchName
        ]);
      }
    } else {
      if (isMilestone1) {
        this.router.navigate([
          '/milestone1-edit-payment-batch',
          paymentBatchName
        ]);
      } else if (isMilestone2) {
        this.router.navigate([
          '/milestone2-edit-payment-batch',
          paymentBatchName
        ]);
      }
    }
  }

  createNewPaymentBatch() {
    const isMilestone1 =
      this.currentTabname === PaymentScheduleTabName.Milestone1;
    const isMilestone2 =
      this.currentTabname === PaymentScheduleTabName.Milestone2;
    if (this.program !== null) {
      if (isMilestone1) {
        this.router.navigate(['/new-payment-batch'], {
          queryParams: { program: this.program }
        });
      } else if (isMilestone2) {
        this.router.navigate(['/csi-new-payment-batch-milestone2']);
      }
    } else {
      if (isMilestone1) {
        this.router.navigate(['/new-payment-batch']);
      } else if (isMilestone2) {
        this.router.navigate(['/new-payment-batch-milestone2']);
      }
    }
  }

  getAllPaymentBatch() {
    const isMilestone1 =
      this.currentTabname === PaymentScheduleTabName.Milestone1;
    const isMilestone2 =
      this.currentTabname === PaymentScheduleTabName.Milestone2;

    if (this.program !== null) {
      if (isMilestone1) {
        this.getCsiMilestone1PaymentBatch();
      } else if (isMilestone2) {
        this.getCsiMilestone2PaymentBatch();
      }
    } else {
      if (isMilestone1) {
        this.getMilestone1PaymentBatch();
      } else if (isMilestone2) {
        this.getMilestone2PaymentBatch();
      }
    }

    this.isM1 = isMilestone1;
    this.isM2 = isMilestone2;
  }

  handlePaymentBatchResponse(pbList: any) {
    if (pbList === null || pbList.length === null || pbList.length === 0) {
      this.loading = false;
    } else {
      this.paymentBatchList = pbList;
      this.totalRecords = this.paymentBatchList.length;

      if (this.totalRecords === 0) {
        this.currentPageInfo = 'No Record Found';
      } else if (this.totalRecords > this.dataViewRecsPerPage) {
        this.currentPageInfo = `Showing 1 - ${this.dataViewRecsPerPage} of ${this.totalRecords} Records`;
      } else {
        this.currentPageInfo = `Showing 1 - ${this.totalRecords} of ${this.totalRecords} Records`;
      }
      this.loading = false;
    }
  }

  getCsiMilestone1PaymentBatch() {
    this.csiService
      .getAllCsiM1PaymentBatch()
      .subscribe(pbList => this.handlePaymentBatchResponse(pbList));
  }

  getCsiMilestone2PaymentBatch() {
    this.csiService
      .getAllCsiM2PaymentBatch()
      .subscribe(pbList => this.handlePaymentBatchResponse(pbList));
  }

  getMilestone1PaymentBatch() {
    this.pmService
      .getAllPaymentBatch(this.settings.AliasName || '')
      .subscribe(pbList => this.handlePaymentBatchResponse(pbList));
  }

  getMilestone2PaymentBatch() {
    this.pmService
      .getMilestone2PaymentBatch()
      .subscribe(pbList => this.handlePaymentBatchResponse(pbList));
  }
  exportToCSV() {
    this.paymentBatchExport = [];
    this.paymentBatchList.forEach(data => {
      this.paymentBatchExport.push({
        PaymentBatchName: data.paymentBatchName,
        PaymentBatchScheduleDate:
          this.datePipe.transform(
            data.paymentBatchScheduleDate,
            'MM/dd/yyyy'
          ) || '',
        AnticipatedPaymentDate:
          this.datePipe.transform(data.anticipatedPaymentDate, 'MM/dd/yyyy') ||
          '',
        ActualPaymentCentralDate:
          this.datePipe.transform(
            data.actualPaymentCentralDate,
            'MM/dd/yyyy'
          ) || '',
        TotalAmount: data.totalAmount,
        NoOfEngagements: data.noOfEngagements,
        PartnersPaid: data.partnersPaid
      });
    });

    let csvFileName = 'PaymentSchedule.csv';
    if (this.program !== null) {
      csvFileName =
        this.currentTabname === PaymentScheduleTabName.Milestone2
          ? 'CSIPaymentSchedule(Milestone2).csv'
          : 'CSIPaymentSchedule.csv';
    }
    this.exportService.exportToCsv(this.paymentBatchExport, csvFileName);
  }
}
